import React from 'react';

import isBot from 'Helpers/SEO/is-bot';
import Footer from 'Layout/Footer/Footer';
import PrivacyChecker from 'Components/App/PrivacyChecker';

export default function FooterGroup() {
  return (
    <React.Fragment>
      {!isBot() &&
        <React.Fragment>
          <PrivacyChecker />
        </React.Fragment>
      }
      <Footer />
    </React.Fragment>
  );
}
